'use strict';


export default angular.module('fplTruescapeComApp.lazyLoad', [])
  .directive('lazyLoad', function() {
    return {
      restrict: 'EA',
      scope: {
        image: '@',
        blur: '@',
        class: '@'
      },
      link: function(scope, element) {
        var smallImg = angular
          .element(element[0].children.blur);
        var realImg = angular
          .element(element[0].children.image);

        realImg.on('load', function() {
          smallImg.addClass('img-hide');
          realImg.removeClass('img-hide');
          realImg.addClass(scope.class);
          realImg.addClass('img-show');
        }).on('error', function(err) {
          console.error(err);
        });
      },
      template: require('./lazyLoad.html'),
    };
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/directives/lazyLoad/lazyLoad.directive.js